export  const COLORS = {
    purple:'#ff82ff',
    darkBlue:'#0f0641',
    blue:'#2610a8',
    lightBlue:'#17a6ff',
    yellow:'#fdd047',
    white:'#faf2ea',
    red:'#f75353',
    lightRed:'#f87764',
    cyan:'#59e9dd'
}